import React from 'react';

var Icon = function Icon() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "15",
    height: "22",
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.375 7.875H14.625C14.9565 7.875 15.2745 8.0067 15.5089 8.24112C15.7433 8.47554 15.875 8.79348 15.875 9.125V19.125C15.875 19.4565 15.7433 19.7745 15.5089 20.0089C15.2745 20.2433 14.9565 20.375 14.625 20.375H3.375C3.04348 20.375 2.72554 20.2433 2.49112 20.0089C2.2567 19.7745 2.125 19.4565 2.125 19.125V9.125C2.125 8.79348 2.2567 8.47554 2.49112 8.24112C2.72554 8.0067 3.04348 7.875 3.375 7.875H4.625",
    stroke: "#44566C",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 1.625V10.375",
    stroke: "#44566C",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.875 4.75L9 1.625L12.125 4.75",
    stroke: "#44566C",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

export default Icon;